<template>
  <div>
    <div v-if="asyncDataStatus_ready" class="cms">
      <v-row justify="space-between">
        <v-col cols="12" sm="10" md="6">
          <v-row>
            <v-col cols="12">
              <DateTimeSelector
                labelDate="Od"
                :date="startDate"
                :time="startTime"
                @change="updateStartDateTime"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <DateTimeSelector
                labelDate="Do"
                :date="endDate"
                :time="endTime"
                @change="updateEndDateTime"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-select
                :items="electronicDevicesWithNull"
                item-text="name"
                item-value="val"
                v-model="electronicDeviceId"
                label="Blagajna"
              ></v-select>
              <FormErrors
                v-if="$v.$error && (!$v.electronicDeviceId.required)"
              >
                <FormErrorsLine v-if="!$v.electronicDeviceId.required" text="Polje je obvezno" />
              </FormErrors>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="invoiceNumber"
                label="Številka računa"
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-select
                :items="usersWithNull"
                item-text="name"
                item-value="val"
                v-model="userId"
                label="Uporabnik"
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                :items="paymentTypesWithNull"
                item-text="name"
                item-value="val"
                v-model="paymentType"
                label="Način plačila"
              ></v-select>
            </v-col>
          </v-row>
          <v-row style="padding:12px;">
            <v-checkbox
              style="flex: 1;"
              color="#0F998E"
              v-model="reverseInvoices"
              label="Storno"
            ></v-checkbox>
            <v-checkbox
              style="flex: 1;"
              color="#0F998E"
              v-model="clientInvoices"
              label="Klienti"
            ></v-checkbox>
          </v-row>
        </v-col>
        <v-col cols="12" md="auto">
          <v-row>
            <v-col cols="12">
              <v-btn
                color="#0F998E"
                class="white--text mt-2 float-right d-inlineblock"
                @click="search"
              >
                Išči
                <v-icon right dark>fas fa-search</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" v-show="loading">
          <AppSpinner />
        </v-col>
      </v-row>
      <div v-show="!loading">
        <v-row v-for="invoice in invoices" :key="invoice.id">
          <v-col>
            <InvoiceCard
              :invoice="invoice"
              :businessUnitCode="businessUnitCode"
              @openInvoicePreview="openInvoicePreview(invoice)"
              @showInvoiceComment="showInvoiceComment"
            />
          </v-col>
        </v-row>
      </div>
    </div>

    <PopupInvoicePreviewWithActions
      ref="popupInvoicePreviewWithActions"
      :invoice="currentInvoice"
      @fillOutInvoice="fillOutInvoice"
      @cancelInvoice="openCancelInvoicePopup"
      @changeInvoice="openChangePaymentMethodPopup"
      @print="showPdfInvoice"
    />

    <PopupCancelInvoice
      ref="popupCancelInvoice"
      @cancelInvoice="cancelInvoice"
    />

    <PopupCanceledInvoceComment
      ref="popupCanceledInvoceComment"
      :comment="comment"
    />

    <PopupChangeInvoice
      :invoice="currentInvoice"
      :paymentTypes="paymentTypes"
      :inivoicePaymentTypeId="currentInvoicePaymentType"
      ref="popupChangeInvoice"
      @changeInvoice="changeInvoice"
    />

    <div v-show="!loading" class="print-control-tape">
      <PrintControlTape
        v-if="company && businessUnit && asyncDataStatus_ready"
        ref="printControlTape"
        :invoices="invoices"
        :invoiceHeader="invoiceHeader"
        :businessUnit="businessUnit"
        :company="company"
        :startDateTime="`${this.startDate} ${this.startTime}`"
        :endDateTime="`${this.endDate} ${this.endTime}`"
      />
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import { mapActions } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import FormErrors from '@/components/FormErrors'
import FormErrorsLine from '@/components/FormErrorsLine'
import DateTimeSelector from '@/components/DateTimeSelector'
import InvoiceCard from '@/components/InvoiceCard'
import PopupInvoicePreviewWithActions from '@/components/PopupInvoicePreviewWithActions'
import PopupCancelInvoice from '@/components/PopupCancelInvoice'
import PopupCanceledInvoceComment from '@/components/PopupCanceledInvoceComment'
import PopupChangeInvoice from '@/components/PopupChangeInvoice'
import PrintControlTape from '@/components/PrintControlTape'
import { md5 } from 'md5js'

export default {
  components: {
    FormErrors,
    FormErrorsLine,
    InvoiceCard,
    DateTimeSelector,
    PopupInvoicePreviewWithActions,
    PopupCancelInvoice,
    PopupChangeInvoice,
    PopupCanceledInvoceComment,
    PrintControlTape
  },
  mixins: [
    asyncDataStatus
  ],
  data () {
    return {
      currentInvoice: null,
      electronicDevicesWithNull: [],
      electronicDeviceId: null,
      usersWithNull: [],
      paymentTypesWithNull: [],
      userId: null,
      paymentType: null,
      invoiceNumber: null,
      startDate: '',
      startTime: '00:00',
      endDate: '',
      endTime: '23:59',
      loading: false,
      resolveFunc: null,
      comment: '',
      reverseInvoices: null,
      clientInvoices: null
    }
  },
  validations: {
    electronicDeviceId: {
      required (val) {
        if (this.invoiceNumber === null || (this.invoiceNumber + '').length === 0) {
          return true
        }
        return val !== null && (this.val + '').length !== 0
      }
    }
  },
  computed: {
    users () {
      return Object.values(this.$store.state.users.items)
    },
    invoiceHeader () {
      return this.$store.state.devices.invoiceHeader
    },
    company () {
      return this.$store.state.companies.myCompany
    },
    currentInvoiceHash () {
      return md5(JSON.stringify(this.currentInvoice))
    },
    businessUnitCode () {
      return this.$store.state.businessUnits.currentBusinessUnit.business_premise_id
    },
    businessUnitId () {
      return this.$store.state.businessUnits.currentBusinessUnit.id
    },
    businessUnit () {
      return this.$store.state.businessUnits.currentBusinessUnit
    },
    electronicDevices () {
      return Object.values(this.$store.state.devices.items)
    },
    paymentTypes () {
      return Object.values(this.$store.state.paymentTypes.items)
    },
    invoices () {
      return Object.values(this.$store.state.invoices.items)
        .filter(inv =>
          (this.clientInvoices ? inv.client !== null : true)
          &&
          (this.reverseInvoices ? inv.reversed_invoice !== null : true)
          &&
          (this.userId && this.userId !== null ? this.userId == inv.user_account : true) // eslint-disable-line
          &&
          (this.electronicDeviceId && this.electronicDeviceId !== null ? this.electronicDeviceId == inv.electronic_device : true) // eslint-disable-line
        )
        .map(invoice => {
          return {
            ...invoice,
            taxGroups: this.taxGroups(invoice.articles)
          }
        })
        .sort((a, b) => {
          return moment(a.date).isBefore(b.date) ? 1 : -1
        })
    },
    currentInvoicePaymentType () {
      return this.currentInvoice !== null ? this.currentInvoice.payment_type : 0
    },
    params () {
      return {
        businessUnitId: this.businessUnitId,
        electronicDeviceId: this.electronicDeviceId,
        number: this.invoiceNumber,
        dateFrom: moment(`${this.startDate} ${this.startTime}:00`).format('YYYY-MM-DDTHH:mm:ss'),
        dateTo: moment(`${this.endDate} ${this.endTime}:59`).format('YYYY-MM-DDTHH:mm:ss'),
        onlyClients: this.clientInvoices,
        paymentType: this.paymentType,
      }
    }
  },
  methods: {
    ...mapActions('paymentTypes', { loadPaymentTypes: 'loadItems' }),
    ...mapActions('devices', { loadDevices: 'loadItems' }),
    ...mapActions('invoices', { najdiSteviloRacunov: 'najdiSteviloRacunov', findInvoices: 'loadItems', updateInvoice: 'updateItem', apiCancelInvoice: 'cancelInvoice' }),
    ...mapActions('invoices', ['clearInvoices', 'setPrints']),
    ...mapActions('users', { loadUsers: 'loadItems' }),
    updateStartDateTime ({ date, time }) {
      this.startDate = date
      this.startTime = time
    },
    updateEndDateTime ({ date, time }) {
      this.endDate = date
      this.endTime = time
    },
    search () {
      this.$v.$touch()
      if (!this.$v.$error) {
        this.loading = true
        this.findInvoices(this.params)
          .finally(response => {
            this.loading = false
          })
      }
    },
    vrniSteviloRacunov () {
      this.$v.$touch()
      if (!this.$v.$error) {
        this.loading = true
        this.najdiSteviloRacunov(this.businessUnitId)
          .finally(response => {
            this.loading = false
          })
      }
    },
    showPdfInvoice () {
      let routeData = this.$router.resolve({ name: 'MyCompanyInvoicePreview', params: { id: this.currentInvoice.id } })
      window.open(routeData.href, '_blank')
    },
    openInvoicePreview (invoice) {
      this.currentInvoice = invoice
      this.$nextTick(() => {
        this.$refs.popupInvoicePreviewWithActions.open()
      })
    },
    openChangePaymentMethodPopup () {
      console.log('aa:', this.currentInvoice)
      this.$refs.popupChangeInvoice.open({ invoice: this.currentInvoice, paymentType: this.currentInvoice.paymentMethod, client: this.currentInvoice.buyerInfo })
    },
    changeInvoice ({ paymentType, client, payments, comment }) {
      const updates = {}
      if (paymentType) {
        updates.payment_type = paymentType.id
        updates.payment_type_name = paymentType.name
        updates.print_payment_type = paymentType.print_payment_type
        this.$refs.popupInvoicePreviewWithActions.updateFullInvoice({ print_payment_type: paymentType.print_payment_type })
      }
      if (client) {
        updates.client = client.id
        updates.client_name = client.name
        this.$refs.popupInvoicePreviewWithActions.updateFullInvoice({ buyerInfo: client })
      } else {
        updates.client = null
        updates.client_name = null
        this.$refs.popupInvoicePreviewWithActions.updateFullInvoice({ buyerInfo: null })
      }
      if (payments) {
        this.$refs.popupInvoicePreviewWithActions.updateFullInvoice({ payments: payments })
      }
      if (comment !== null) {
        this.$refs.popupInvoicePreviewWithActions.updateFullInvoice({ comment })
      }
      let issuer
      if (this.currentInvoice.user_account !== null) {
        issuer = this.currentInvoice.user_account
      }
      this.updateInvoice({ invoiceId: this.currentInvoice.id, updates, payments, comment, issuer })
        .then(invoice => {
          if (invoice.invoice_id) {
            this.$refs.popupInvoicePreviewWithActions.updateFullInvoice({ invoice_id: invoice.invoice_id })
          }
          // if (client) {
          Vue.set(this.currentInvoice, 'buyerInfo', client)
          // }
          if (comment !== null) {
            Vue.set(this.currentInvoice, 'comment', comment)
          }
          if (payments) {
            Vue.set(this.currentInvoice, 'payments', payments)
          }
        })
        .catch(anErr => {
          this.$notify({ type: 'error', text: 'Prišlo je do napake pri shranjevanju klienta.' })
        })
    },
    openCancelInvoicePopup () {
      this.$refs.popupCancelInvoice.open()
    },
    cancelInvoice (comment) {
      this.apiCancelInvoice({ oldInvoice: this.currentInvoice, comment })
        .then(response => {
          this.loading = true
          this.findInvoices(this.params)
            .finally(response => {
              this.loading = false
              const updatedInvoice = this.invoices.find(invoice => invoice.id === this.currentInvoice.id)
              if (updatedInvoice) {
                this.openInvoicePreview(updatedInvoice)
              }
            })
        })
        .catch(anErr => {
          this.$notify({
            type: 'error',
            text: 'Prišlo je do napake pri storniraju računa.'
          })
        })
    },
    fillOutInvoice (invoice) {
      this.currentInvoice = invoice
    },
    showInvoiceComment (comment) {
      this.comment = comment
      this.$refs.popupCanceledInvoceComment.open()
    },
    taxGroups (articles) {
      const groups = {}
      articles.forEach(article => {
        const key = article.tax_level_value.toString()
        if (groups[key]) {
          groups[key].taxable_amount += article.taxable_amount
          groups[key].tax_amount += article.tax_amount
          groups[key].price += article.total_amount
        } else {
          groups[key] = {
            tax_level_value: article.tax_level_value,
            taxable_amount: article.taxable_amount,
            tax_amount: article.tax_amount,
            price: article.total_amount
          }
        }
      })
      return Object.values(groups)
    }
  },
  created () {
    if (!this.$store.state.businessUnits.currentBusinessUnit) {
      this.$notify({ type: 'error', text: 'Potrebna je vsaj ena aktivna poslovna enota' })
    } else {
      const yesterday = moment().add(-1, 'days').format('YYYY-MM-DD')
      const today = moment().format('YYYY-MM-DD')
      this.startDate = yesterday
      this.endDate = today
      Promise.all([
        this.clearInvoices(),
        this.loadPaymentTypes(),
        this.loadDevices(),
        this.loadUsers()
      ])
        .then(response => {
          this.electronicDevicesWithNull.push({
            name: 'Vse naprave',
            val: null
          })
          this.electronicDevices.forEach(device => {
            this.electronicDevicesWithNull.push({
              name: `${device.name} (${device.electronic_device_id})`,
              val: device.id
            })
          })
          this.usersWithNull.push({
            name: 'Vsi uporabniki',
            val: null
          })
          this.paymentTypesWithNull.push({
            name: 'Vsi tipi plačila',
            val: null
          })
          this.users.forEach(user => {
            this.usersWithNull.push({
              name: `${user.moniker}`,
              val: user.id
            })
          })
          this.paymentTypes.forEach(ptype => {
            this.paymentTypesWithNull.push({
              name: `${ptype.name}`,
              val: ptype.id
            })
          })
          this.vrniSteviloRacunov()
          this.asyncDataStatus_fetched()
        })
        .catch(anErr => {
          this.$notify({
            type: 'error',
            text: 'Prišlo je do napake pri nalaganju podatkov.'
          })
        })
    }
  },
  watch: {
    userId (val) {
      console.log(val)
    }
  }
}

</script>

<style lang="scss" scoped>
.print-a4-invoice {
  display: none;
}
@media print {
  .print-a4-invoice {
    display: block;
  }
}

.print-control-tape {
  display: none;
}
@media print {
  .print-control-tape {
    display: block;
    font-size: 10px;
  }
}
</style>

<style lang="scss">
@media print {
  .cms,
  .header,
  .v-navigation-drawer,
  .footer {
    display: none;
  }
  .v-content {
    padding: 0px !important;
  }
}
</style>
